import React from "react";
import { connect } from "react-redux";
import IconNotification from "components/v3/icon-notification/IconNotification";
import AbbaWrapperContainer from "containers/v3/AbbaWrapperContainer";
import abba from "ducks/abba";
import offerActions from "ducks/offer";
import { ABBA_CONFIGS } from "common/constants/Constants";
import isEmpty from "lodash.isempty";

export function mapStateToProps(state) {
    const {
        abba: {
            config
        },
        offer: {
            allOffers
        }
    } = state;

    return {
        abbaConfig: config,
        allOffers
    };
}

export const mapDispatchToProps = (dispatch) => ({
    getAbbaConfig() {
        return dispatch(abba.getAbbaConfig());
    },

    addOffer(newOffer) {
        dispatch(offerActions.addOffer(newOffer));
    }
});

class OffersNotificationContainer extends React.PureComponent {
    componentDidMount() {
        const {
            abbaConfig,
            addOffer
        } = this.props;

        const upsellOffer = abbaConfig[ABBA_CONFIGS.UPSELL_OFFER];

        if (!isEmpty(upsellOffer)) {
            addOffer(upsellOffer);
        }
    }

    componentDidUpdate(prevProps) {
        const {
            abbaConfig,
            addOffer
        } = this.props;

        if (prevProps.abbaConfig !== abbaConfig) {
            const upsellOffer = abbaConfig[ABBA_CONFIGS.UPSELL_OFFER];

            if (!isEmpty(upsellOffer)) {
                addOffer(upsellOffer);
            }
        }
    }

    render() {
        const {
            location,
            allOffers
        } = this.props;

        const notSeenOffers = allOffers.filter((offer) => !offer.seen).length;

        return (
            <AbbaWrapperContainer location={ location }>
                <IconNotification notificationText={ notSeenOffers > 0 ? notSeenOffers.toString() : null } />
            </AbbaWrapperContainer>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OffersNotificationContainer);
